<template>
	<page-container :page="page" :locale="locale">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section class="main-content background-light">
			<filter-buttons :items="categories" :filter="filter" @change-filter="filter = $event" />
			<image-grid :items="galleryFiltered" :filter="filter" @change-filter="filter = $event" />
		</section>

		<contentblocks :items="page.contentblocks" />
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const filter = ref('showAll');

const { data: gallery } = await useWebsiteFetch('gallery', {
	query: { language: locale.value },
	key: `${locale.value}/gallery`,
});

const categories = [
	...new Set(gallery.value.map(({ galleryCategorie }) => galleryCategorie && galleryCategorie.header)),
];

const galleryFiltered = computed(() => {
	if (filter.value === 'showAll') {
		return gallery.value;
	}

	return [...gallery.value].filter((item) => {
		if (!item.galleryCategorie) {
			return false;
		}

		return item.galleryCategorie.header === filter.value;
	});
});
</script>

<style lang="scss" scoped>
.background-light {
	margin-top: 75px;
}
</style>
